<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AnCykh/tc-custom/9781460337547.jpg?1726519033199" alt="This image is the cover for the book Mountain Rescue, Echo Mountain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mountain Rescue, Echo Mountain
      </h1>
      <p class="bookDescription body article font2">
        <b>In the rugged mountains of Washington State, he will protect her with his life . . . </b><br/><br/>It took just one look in Quinn Donovan’s eyes and Wilhelma “Billie” Bronson knew the search and rescue volunteer had saved her life. Again. But this time her fall down a mountain was no accident. It seems her past has come back to haunt her, and trusting Quinn to protect her is the best way to stay alive.<br/><br/>Before long, though, old feelings resurface, and being around him becomes more challenging than figuring out who wants to hurt her. And why they’d stop at nothing to spoil any possible future with Quinn . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hope White
      </h2>
      
      <p class="authorDescription body article">With a degree in journalism, Hope White started her writing career as a reporter but found she wanted to do more than report the facts &ndash; she wanted to give readers a happy ending. Now she&rsquo;s thrilled to be combining mystery, adventure and romance for Love Inspired Suspense. When not at her computer, you&rsquo;ll find Hope hiking in the Cascade Mountains or enjoying a cup of tea with friends. You can find her at: www.hopewhiteauthor.com or facebook.com/hopewhiteauthor</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d1d6dca6